import React, { useEffect, useState } from "react";
import { css } from "emotion";
import BillingTitle from "./BillingTitle";
import { boxStyles, colors } from "../../styles/theme";
import InvoiceRow from "./InvoiceRow";
import { useContext } from "react";
import { GlobalContext } from "../../context/GlobalState";
import workspaces from "../../services/api/workspaces";

const InvoiceList = () => {
  const { currentWorkspace } = useContext(GlobalContext);
  const [invoiceList, setInvoiceList] = useState([]);

  const getInvoices = async () => {
    try {
      const { data } = await workspaces.invoiceHistory(currentWorkspace);
      setInvoiceList(data.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getInvoices();
  }, []);

  return (
    <div className={container}>
      <BillingTitle title="Invoice History" />

      <div className="heading-row">
        <p>ID</p>
        <p>Date</p>
        <p className="last">Amount</p>
      </div>
      {invoiceList.length > 0 ? (
        invoiceList.map((invoice) => (
          <InvoiceRow invoice={invoice} key={invoice.id} />
        ))
      ) : (
        <div className="empty-placeholder">
          <p>Your invoices will appear here each month.</p>
        </div>
      )}
    </div>
  );
};

export default InvoiceList;

const container = css`
  padding: ${boxStyles.standardPadding};

  .heading-row {
    display: flex;
    padding: ${boxStyles.standardPadding} 0;
    p {
      flex: 1;
      color: ${colors.title};
      font-weight: bold;
    }
    .last {
      flex: 2;
    }
  }
  
  .empty-placeholder {
    border-radius: 8px;
    height: 77px;
    margin-top: 15px;
    background-color: ${colors.inputBackground};
    align-items: center;
    justify-content: center;
    display: flex;
    flex: 1;
    
    p {
      font-size: 14px;
      color: ${colors.subtitleColor};
    }
  }

  @media screen and (min-width: ${boxStyles.desktopBreak}) {
    padding: ${boxStyles.desktopPadding} 0;
  }
`;
